module.exports = __webpack_public_path__ + "static/media/risotto.3eab58cd.svg";